<template>

  <div class="percent_box">
      <div class="percent_left" :style="{width:num+'%'}"></div>
  </div>

</template>
<script>

export default {
  name: "limit_percent",
  data () {
    return {
      percent: 0,
    };
  },
  props: {
    num: {
      type: Number,
      default: 0,

    }
  },
  components: {
  },
  methods: {

  },
  watch: {
    num (old, after) {
      if (old == after) {
        return
      }
      this.percent = old;
    }
  }
}
</script>
<style scoped>
.percent_box {
  /* width: 100%; */
  border: 1px solid #ed0e0f;
  height: 15px;
  border-radius: 5px;
  overflow: hidden;
}
.percent_box .percent_left {
  /* width: 20%; */
  height: 100%;
  background-color: #ff8989;
}
</style>


// WEBPACK FOOTER //
// src/components/pintuan/limit_percent.vue